module.exports = __webpack_public_path__ + "static/media/ourTeamFourth.43623089.jpg";